import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const MarketPlaceIcon: React.FC<SvgIconDefaultProps> = ({ className }) => {
  return (
    <CustomSvg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7.00488 18.1501V16.0801"
        stroke="#5C5C5C"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12.125 18.15V14.01"
        stroke="#5C5C5C"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M17.2451 18.1499V11.9299"
        stroke="#5C5C5C"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M17.2449 5.8501L16.7849 6.3901C14.2349 9.3701 10.8149 11.4801 7.00488 12.4301"
        stroke="#5C5C5C"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M14.3154 5.8501H17.2454V8.7701"
        stroke="#5C5C5C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.125 22H15.125C20.125 22 22.125 20 22.125 15V9C22.125 4 20.125 2 15.125 2H9.125C4.125 2 2.125 4 2.125 9V15C2.125 20 4.125 22 9.125 22Z"
        stroke="#5C5C5C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </CustomSvg>
  );
};

export default MarketPlaceIcon;
